import type { CSSProperties, ReactNode } from "react";
import { cn } from "@/lib/utils";
import { CountBadge } from "./Tag";

interface ChipProps {
  selected?: boolean;
  onClick?: () => void;
  count?: number;
  children: ReactNode;
  className?: string;
}

/**
 * Filter chip — Figma §5.2. h36, r20, hairline border.
 * Tanlangan: brand-tag fon (default orange / Click ko'k). Tanlanmagan: line fon.
 * Ixtiyoriy trailing count badge.
 */
export function Chip({ selected = false, onClick, count, children, className }: ChipProps) {
  const style: CSSProperties = selected
    ? {
        background: "var(--brand-tag-accent-bg, var(--primary))",
        color: "var(--brand-tag-accent-fg, var(--c-on-brand))",
        boxShadow: "var(--brand-tag-accent-shadow, none)",
      }
    : {
        // --c-line brendga bog'liq "stroke" tokeni (Click/Payme/Zoomrad da
        // qattiqroq/qoraroq bo'lishi mumkin) — fill uchun mos emas. Shuning
        // uchun neytral pill fon har doim --c-elevated-2 (brand-agnostic).
        background: "var(--c-elevated-2)",
        color: "var(--c-text)",
        boxShadow: "inset 0 0 0 0.5px var(--c-line-input)",
      };

  return (
    <button
      type="button"
      role="tab"
      aria-selected={selected}
      onClick={onClick}
      style={style}
      className={cn(
        "inline-flex h-9 shrink-0 items-center gap-1.5 rounded-[20px] px-3 text-sm font-medium",
        "transition-all active:scale-95",
        className,
      )}
    >
      {children}
      {count != null && count > 0 && <CountBadge selected={selected}>{count}</CountBadge>}
    </button>
  );
}
